<template>
    <div class="u-fit">
        <b-form-file id="profile_image"
                     name="profile_image"
                     v-model="file"
                     placeholder=""
                     accept="image/jpeg, image/png, image/gif"></b-form-file>

        <div v-if="file" class="mt-3">アップロード画像: {{ file.name }}</div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                file: null,
            };
        },
    }
</script>

<style scoped>
</style>